import UserAccessManagement from "@/src/screens/uam/uam";

export default function UserAccessManagementScreen() {
  return <UserAccessManagement />;
}
